var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOzfNavGiving = function SvgOzfNavGiving(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18048",
    "data-name": "Rectangle 18048",
    width: 34,
    height: 34,
    fill: "#595959",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-ozf-nav-giving"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ozf-nav-giving",
    clipPath: "url(#clip-ozf-nav-giving)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_7",
    "data-name": "Mask Group 7",
    transform: "translate(0.5 0.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1879648_care_donate_health_health_care_heart_icon",
    "data-name": "1879648_care_donate_health_health care_heart_icon",
    transform: "translate(0 5.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M28.387,19.551h0c.391-.32,4.477-4.193,5.259-5.614,0,0,2.1-2.558,0-4.442a3.377,3.377,0,0,0-5.259.924,3.357,3.357,0,0,0-5.224-.959c-2.1,1.883,0,4.442,0,4.442C23.945,15.323,27.889,19.089,28.387,19.551Z",
    transform: "translate(-4.152 -8.576)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M32.268,23.925l-6.823,1.919v.036a2.694,2.694,0,0,1-.284,2.025,2.722,2.722,0,0,1-1.706,1.35,2.9,2.9,0,0,1-2.168-.249l-3.944-2.2.355-.675,3.944,2.2a2.01,2.01,0,0,0,1.564.178,2.034,2.034,0,0,0,1.244-.995A2.187,2.187,0,0,0,24.7,26.7a1.65,1.65,0,0,0-.817-1.706l-9.559-5.33a2.953,2.953,0,0,0-2.345-.284h-.036C11.693,19.412,1.423,22.361,1,22.468H.962l2.168,7.427L9.987,27.94c.711.426,5.934,3.66,6.574,4.051a3.9,3.9,0,0,0,2.914.213c.036,0,14-3.98,14-3.98a2.347,2.347,0,0,0,1.386-2.878A2.071,2.071,0,0,0,32.268,23.925Z",
    transform: "translate(-0.962 -10.178)",
    fill: "#595959"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOzfNavGiving);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ozf-nav-giving.8f74eebd6b943a982a188653f5f24bd9.svg";